export default {
	// header Menu
	user_menu_kccIntro: 'KCC簡介',
	user_menu_product: '產品',
	user_menu_market: '市場',
	user_menu_productSupport: '產品支持',
	user_menu_customerSupport: '客戶支持',

	user_marketMain: 'Market 主要的',
	user_functionMain: 'Function 主要的',

	// KCC소개
	user_common_kccIntro : 'KCC簡介',
	user_common_kccIntro_kccam : 'KCC Advanced Materials',
	user_common_kccIntro_globalNetwork : '全球網絡',
	user_common_kccIntro_newsRoom : 'Newsroom',
	user_common_next : '下一個',
	user_common_complete : '完成',

	user_common_View : '視圖',
	user_common_By: '由',
	user_common_store: '商店',
	user_common_RelatedApplication: '相關申請',

	// product 정보
	user_common_product : '產品',
	user_common_product_application_etc : '等等',
	user_common_product_mouseover_txt : '更多',

	user_product_guide_tit : 'KTMC series selection guide(LSI devices)',
	user_product_guide_Package : '包裹',
	user_product_guide_Product : '產品',
	user_product_guide_Features : '特徵',
	user_product_guide_Type : '鉛字',
	user_product_guide_Devices : '計謀',
	user_product_guide_LSI : 'LSI',

	user_product_LeadFrame : '引線框',
	user_product_Substract : '承印物料',
	user_product_Description : '描述',
	user_product_introduction_tit : 'KCC EMC 引言(Power Module FP)',
	user_product_introduction : '引言',

	user_product_TestItem : '測試項目',
	user_product_Unit : '單位',
	user_product_Typical : '典型例子',
	user_product_TestMethod : '測試方法',
	user_product_Value : '價值',

	//datasheet modal
	user_datasheetModal_showList : '查看完整清單',
	user_datasheetModal_swalWithOptions_tit : '檢查修改',
	user_datasheetModal_swalWithOptions_contents : '請檢查多行',

	// Technical DataSheet
	user_common_product_technicalDataSheet : '技術資料表',

	// product dataSheet 제목
	user_common_product_productDataSheet : '產品數據表',

	// datasheet 하단 버튼
	user_common_product_dataSheet_compareBtn : '產品比較',

	// Similar Product
	user_common_product_similarProduct : '類似產品',
	user_common_product_similarProduct_no : '號碼',
	user_common_product_similarProduct_series : '系列',
	user_common_product_similarProduct_name : '產品名',
	user_common_product_similarProduct_summary : '摘要',

	user_common_product_ViewSummary : '觀看摘要',

	// classification 관련 내용
	user_common_productClassification : '產品分類',
	user_common_application : 'Application',
	user_common_detail_application : 'Application 細部',

	// markets
	user_common_market : '市場',

	// function
	user_common_function : '功能',

	// page footer
	user_common_footer_address : '首尔特别市瑞草区沙坪大路三444 | 客戶商談室 080 - 022 - 8200, 代表號碼 02 - 3480 - 5000',
	user_common_footer_copyright : 'COPYRIGHT (C) 2017 KCC CORPORATION ALL RIGHTS RESERVED',

	user_common_footer_lang : '語言',
	user_common_footer_repreNumber : '總號碼',
	user_common_footer_familySite : '家庭網站',
	user_common_footer_familySite_subTxt1 : '介紹KCC的家庭網站。',
	user_common_footer_familySite_subTxt2 : '選擇以下子公司後移動到相應網站。',
	user_common_footer_familySite_kccCorporation : 'KCC Corporation',
	user_common_footer_familySite_facebook : 'KCC官方facebook',
	user_common_footer_familySite_blog : 'KCC官方博客',
	user_common_footer_familySite_automobileMt : 'KCC汽車維修塗料',
	user_common_footer_familySite_shipPaint : 'KCC船舶塗料',
	user_common_footer_familySite_basketballTeam : 'KCC 宙,斯盾職業籃球團',
	user_common_footer_familySite_colorDesign : 'KCC 彩色&設計中心',
	user_common_footer_familySite_glass : 'KCC玻璃',
	user_common_footer_familySite_homecc : '家庭種子',
	user_common_footer_familySite_construction : 'KCC建設',
	user_common_footer_familySite_kccsilicone : 'KCC SILICONE',
	user_common_footer_familySite_genmgang : '金剛休閒',
	user_common_footer_familySite_basildon : '巴西頓',
	user_common_footer_policyPrivacy : '個人信息處理方針',

	//// Main페이지
	// popup
	user_main_popup_header : '新產品問世',
	user_main_popup_footer : '一週內不彈出彈窗。',
	user_main_popup_close : '關閉',

	user_main_youtube_tit : 'KCC的高級材料',
	user_main_youtube_play : '玩',


	// 헤더
	user_main_slider_header1_tit : 'EMC有機材料',
	user_main_slider_header1_subtxt : '電磁兼容性',

	user_main_slider_header2_tit : 'EMI 放射線',
	user_main_slider_header2_subtxt : '電磁干擾',

	user_main_slider_header3_tit : 'EMS 感性靈',
	user_main_slider_header3_subtxt : '電磁脆弱性',

	user_main_globalNetwork : '全球網絡細節',

	//// KCC 소개 페이지
	// 헤더
	user_intro_introKcc_header_tit : 'KCC 導言',
	user_intro_introAM_header_tit : 'KCC AM',
	user_intro_introKcc_header_subtxt : 'KCC 介紹文章。',
	user_intro_introAM_header_subtxt : 'KCC AM 引子',
	user_intro_introAM_body_tit : '未來行業的坐標，在KCC先進材料中找到',
	user_intro_introAM_body_subtxt1 : 'KCC的先進材料分為<strong>有機材料，無機材料和復合材料</strong> <br/>，並為每種材料提供給各個行業。',

	user_intro_introAM_body_content1_tit : '有機材料',
	user_intro_introAM_body_content1_subtxt : 'KCC有機材料包括半導體密封劑（EMC）和電氣和電子粘合劑。\ n'
											+'KCC有機材料用於大多數使用半導體的產品，冰箱和電視等一般家用電器，工業設備和汽車。\ n'
											+'隨著反映先進IT技術的產品數量的增加，全球半導體市場正在擴大，對KCC有機材料的需求也在增加。\ n \ n'
											+'半導體材料包括各種粘合劑（DAP，底部填充膠）。\ nKCC半導體材料針對世界一流的半導體製造商的工藝進行了優化，與其他公司相比，表現出卓越的性能。\ n'
											+'顯示材料包括UV成型材料和UV密封材料，並以更高的質量和先進的技術向國內外領先的客戶進行銷售和推廣。',
	user_intro_introAM_body_content2_tit : '有機材料無機材料',
	user_intro_introAM_body_content2_subtxt : 'KCC無機材料可以分為'+'<strong>金屬陶瓷</strong>和<strong>陶瓷基材</strong>。\n \n'
											+'我們正在利用無機材料領域的累積技術和經驗來開發和供應新型先進的無機材料-精細陶瓷。\n'
											+'KCC通過引入最新的設備和先進的技術來構建高效的自動化流程，\n'
											+'我們通過應用嚴格的集成質量管理體係來生產KCC金屬陶瓷。 \n尤其是，KCC的VI陶瓷管（真空滅弧室）擁有世界第一的市場份額。\n'
											+'連續12年被KOTRA評選為2020年世界級產品。\n \n'
											+'陶瓷基板成型（Tape Casting）技術用於生產功率模塊的核心材料陶瓷基板產品。\n各種陶瓷基板技術，例如以氧化鋁（Al2O3）和氮化鋁（AIN）為原料的DCB基板。有。\n'
											+'根據最近對電動汽車的需求增長，正在考慮將HIC基板應用於精細控制汽車電子設備用電的控制單元。\n'
											+'諸如Si3N4 AMB和ZTA DCB之類的高可靠性基板被應用於輸出電力輸出並需要轉換交流和電流的功率部分。',

	user_intro_introAM_body_content3_tit : '每種材料都供應給各個行業',
	user_intro_introAM_body_content3_subtxt : '玻璃纖維長纖維是KCC的複合材料，與葉蠟石和石灰石等無機原料混合併在1500℃或更高的高溫下熔融'
											+'<br/>是一種通過細孔以微米為單位（百萬分之一米）的細孔形式拉出的產品。 <br/>普通塑料易碎，耐熱性差，尺寸穩定性差。'
											+'有一個缺點。 <br/>但是，如果在此處使用長玻璃纖維，則具有高物理強度的增強塑料會脫胎換骨。 <br/>長玻璃纖維不僅具有絕緣性，而且還具有尺寸穩定性和強度'
											+'因為它補充了後背的特性。<br/>'
											+'<br/> KCC的長玻璃纖維包括短切原絲，短切原絲氈，<br/> DirectRoving，常規'
											+'常規粗紗，編織粗紗組織等。<br/> KCC的長玻璃纖維不僅用於LCD電視和顯示器的後面板，而且還用於電氣/電子產品。'
											+'它被廣泛用於汽車和民用建築等行業。',
	// body
	user_intro_introKcc_introSection_addr : '344, Sapyeong-daero, Seocho-gu, Seoul, South Korea',
	user_intro_introKcc_introSection_roundSpan_addr : '總公司地址',
	user_intro_introKcc_introSection_roundSpan_establish : '成立日期',
	user_intro_introKcc_introSection_roundSpan_establish_contxt : '1958年8月12日',
	user_intro_introKcc_introSection_roundSpan_employees : '僱員人數',
	user_intro_introKcc_introSection_roundSpan_employees_number : '名',
	user_intro_introKcc_introSection_roundSpan_criteriaAsDate1 : '截至2020年9月30日',
	user_intro_introKcc_introSection_roundSpan_sales : '銷售',
	user_intro_introKcc_introSection_roundSpan_criteriaAsDate2 : '以2023年爲基準',
	user_intro_introKcc_introSection_roundSpan_unit : '單位:100萬韓元',

	user_intro_introKcc_detail_tit : 'KCC業務詳情',
	user_intro_introKcc_detail_header1_tit : '內建材料',
	user_intro_introKcc_detail_header1_contxt1 : '天花板物料、絕緣物料、石膏板',
	user_intro_introKcc_detail_header2_tit : '昌和齋',
	user_intro_introKcc_detail_header2_contxt1 : '普通窗口，陽臺窗口，系統窗口',
	user_intro_introKcc_detail_header3_tit : '油漆',
	user_intro_introKcc_detail_header3_contxt1 : '建築塗料、汽車塗料和船舶塗料',
	user_intro_introKcc_detail_header3_contxt2 : '植物顏料, 工業塗料',
	user_intro_introKcc_detail_header4_tit : '狀態',
	user_intro_introKcc_detail_header4_contxt1 : '有機物料(EMC),無機物料(AM,DCB)',
	user_intro_introKcc_detail_header4_contxt2 : '複合材料',

	//// NewRoom
	user_intro_newsroom_header_tit : 'Newsroom',
	user_intro_newsroom_header_subtxt : 'Newsroom詳細內容。',
	user_intro_newsroom_search_placeholder : '搜索標題',

	// newroom_view
	user_intro_newsroom_view_relatedProduct : '相關產品',
	user_intro_newsroom_view_regDate : '登記日',
	user_intro_newsroom_view_hits : '查詢數',
	user_intro_newsroom_view_list : '目錄',

	// theGlobalNetwork
	user_intro_globalNetwork_header_tit: 'Global Network',
	user_intro_globalNetwork_header_subtxt: '全球網絡詳細信息。',

	user_common_nowLoading : '數據加載中。',
	user_common_noData : '沒有數據。',
	user_common_korea : '大韓民國',
	user_common_japan : '日本',
	user_common_china : '中國',
	user_common_veitnam : '越南',
	user_common_malaysia : '馬來西亞',
	user_common_singapore : '新加坡',
	user_common_indonesia : '印尼',
	user_common_india : '印度',
	user_common_uae : '阿拉伯聯合酋長國',
	user_common_turkey : '土耳其',
	user_common_germany : '德國',
	user_common_uk : '英國',

	// customerSupport_inquery 1:1 문의
	// 상단 배너
	user_customerSupportInquiry_noticeBanner_tit : '1對1諮詢使用指南',
	user_customerSupportInquiry_noticeBanner_txt1 : '與相關公告欄性質不符的內容、辱罵、廣告等可以在事前沒有通知的情況下，由管理者刪除。',
	user_customerSupportInquiry_noticeBanner_txt2 : '1:1諮詢的回答僅通過電子郵件發送，',
	user_customerSupportInquiry_noticeBanner_txt3 : '個人信息管理方針',
	user_customerSupportInquiry_noticeBanner_txt4 : '認內容。',

	user_customerSupportInquiry_noticeBanner_txt : '與相關公告欄性質不符的內容、辱罵、廣告等可以在事前沒有通知的情況下，由管理者刪除。 1:1諮詢的回答僅通過電子郵件發送，請確認個人信息相關政策個人信息處理方針。',
	user_customerSupportInquiry_header_tit : '1:1諮詢',
	user_customerSupportInquiry_oneToOne_label : '詢價種類',
	user_customerSupportInquiry_oneToOne_placeholder : '選擇',
	user_customerSupportInquiry_essential_tit_header : '必填內容',
	user_customerSupportInquiry_essential_tit_subTxt : '1:1諮詢時必填內容。',
	user_customerSupportInquiry_essential_email_label : '電子郵件',
	user_customerSupportInquiry_essential_email_placeholder1 : '請輸入電子郵箱。',
	user_customerSupportInquiry_essential_email_placeholder2 : '請輸入電子郵件服務器。',
	user_customerSupportInquiry_essential_company_label : '公司名稱',
	user_customerSupportInquiry_essential_company_placeholder : '請輸入公司名。',
	user_customerSupportInquiry_elective_tit : '選擇輸入',
	user_customerSupportInquiry_elective_phone_label : '手機號碼',
	user_customerSupportInquiry_elective_name_label : '稱謂',
	user_customerSupportInquiry_elective_name_placeholder1 : '請輸入姓。',
	user_customerSupportInquiry_elective_name_placeholder2 : '請輸入名字。',
	user_customerSupportInquiry_elective_department_label : '部門',
	user_customerSupportInquiry_elective_department_placeholder : '請輸入部門。',
	user_customerSupportInquiry_elective_tel_label : '電話號碼',
	user_customerSupportInquiry_elective_country_label : '國家',
	user_customerSupportInquiry_elective_country_placeholder : '請輸入國家。',
	user_customerSupportInquiry_elective_city_label : '城市',
	user_customerSupportInquiry_elective_city_placeholder : '請輸入城市。',
	user_customerSupportInquiry_context_tit : '諮詢內容',
	user_customerSupportInquiry_context_label : '詢盤題目',
	user_customerSupportInquiry_context_placeholder1 : '請輸入諮詢題目。',
	user_customerSupportInquiry_context_placeholder2 : '請輸入諮詢內容。',
	user_customerSupportInquiry_attach_tit : '附件',
	user_customerSupportInquiry_attach_dropzone_tit : '拖動上傳要上傳的文件。',
	user_customerSupportInquiry_attach_dropzone_subtit : '（或點擊此處，選擇要在PC上上傳的文件。）',

	// Swal
	user_customerSupportInquiry_swal_inquiry : '1:1諮詢',
	user_customerSupportInquiry_swal_inquiry_save : '1:1諮詢結果',
	user_customerSupportInquiry_swal_save_success : '傳輸完成',
	user_customerSupportInquiry_swal_save_error : '傳輸失敗',
	user_customerSupportInquiry_swal_inquiry_needCategory : '請選擇1:1諮詢種類。',
	user_customerSupportInquiry_swal_inquiry_needlQuestion : '填一下1:1諮詢的詳細問題。',
	user_customerSupportInquiry_swal_inquiry_needEssential : '必填內容遺漏',
	user_customerSupportInquiry_swal_inquiry_needEmail : '請填寫電子郵件輸入欄。',
	user_customerSupportInquiry_swal_inquiry_needCompany : '請填一下公司名稱。',
	user_customerSupportInquiry_swal_inquiry_needContext : '諮詢內容遺漏',
	user_customerSupportInquiry_swal_inquiry_needTitle : '請填一下諮詢題目。',
	user_customerSupportInquiry_swal_inquiry_needValidEmail : '這是一個無效的電子郵件地址。',

	// customerSupport_contact_vue
	//헤더
	user_customerSupportContact_header_tit : '聯繫',
	//body
	user_customerSupportContact_country_korea : '大韓民國',
	user_customerSupportContact_country_china : '中國',
	user_customerSupportContact_country_japan : '日本',

	user_customerSupportContact_country_korea_branch_hq_tit : 'KCC總公司',
	user_customerSupportContact_country_korea_branch_hq_addr : '首爾特別市瑞草區沙坪大路344',
	user_customerSupportContact_country_china_branch_kunshan_tit : 'KCC (KUNSHAN)',
	user_customerSupportContact_country_china_branch_kunshan_addr : '11F, Shanghai HNA Building,No_898 Puming Road, Shanghai, China',

	user_customerSupportContact_country_china_branch_guangzhou_tit : 'KCC (GUANGZHOU)',
	user_customerSupportContact_country_china_branch_guangzhou_addr : 'Room 3703&3707, ZhongTai International square, NO_161 Linhe West Road, Guangzhou, China',
	user_customerSupportContact_country_japan_branch_yurakucho_tit : 'KCC Japan',
	user_customerSupportContact_country_japan_branch_yurakucho_addr : 'Yurakucho Denki Bldg_ South wing 12F, 1-7-1, Yurakucho, Chiyoda-ku, Tokyo, Japan',

	user_customerSupportContact_manager_tit : '聯繫負責人',
	user_customerSupportContact_manager_tel : '聯絡處',
	user_customerSupportContact_manager_email : '電子郵件',

	//#### Market
	//## Market + Function 메인 페이지

	//### 헤더
	user_market_main_header_tit : 'Market',
	user_market_main_header_subtxt : 'KCC的先進材料被用於在半導體，汽車，電氣/電子/家用電器，<br/>建築和船舶等各個行業中實現完美的性能。',
	user_market_list_header_subtxt : '市場 羅列.',
	user_market_view_header_subtxt : 'KCC为半导体、移动、汽车、电子/家电、建筑、船舶等多种产业提供最尖端材料。 KCC通过变化和革新，通过最好的尖端素材提高顾客的未来价值',

	user_market_main_descr1 : 'KCC為各種行業提供最先進的材料，例如半導體，汽車，電氣/電子/家用電器，建築和船舶。',
	user_market_main_descr2 : 'KCC通過最好的高科技材料通過變革和創新來提高客戶的未來價值。',

	user_market_main_function_tit : 'Function',
	user_market_main_function_descr1 : 'KCC supplies customers with the highest quality products that reflect the various needs of the market.',

	//### 본문
	user_market_main_button_market : '移動到 市場 屏幕',
	user_market_main_button_function : '移動到 Function 屏幕',

	//## Market 페이지
	//### market View
	//### Related Document
	user_market_relatedDocu_tit : '有關文件',
	user_market_relatedDocu_docuName : '文檔名',
	user_market_relatedDocu_docuType : '文檔類型',
	user_market_relatedDocu_fileType : '文件形態',
	user_market_relatedDocu_download : '下載',
	user_market_relatedDocu_share : '國有',
	user_market_references : '參照',

	//market - function 관련
	user_market_function_subtit : '功能清單',
	user_market_function_detail_tit : 'KCC向顾客提供反映市场多种必须的最高品质产品.',

	// 통합검색 (productsupport_integratedSearch)
	integratedSearch_tit : '綜合搜索',
	integratedSearch_quickLink : '快速鏈接',
	integratedSearch_inputSearch : '請輸入搜索詞。',
	integratedSearch_searchResults : '總共搜索了',
	integratedSearch_founded : '條',
	integratedSearch_ProductName : '產品',
	integratedSearch_Material : '材料',
	integratedSearch_Function : '函數',
	integratedSearch_MarketName : '市場',
	integratedSearch_FunctionName : '函數名',

	integratedSearch_ApplicationName : '適用',
	integratedSearch_ApplicationClassification : '使用分類',
	integratedSearch_DetailApplication : '詳細材料',
	integratedSearch_Product : '產品',

	// 기술지원 목록표
	integratedSearch_tecSupport_tit : '技術支援',
	integratedSearch_tecSupport_placeHolder : '文件搜尋',

	integratedSearch_tecSupport_commonDoc : '公司通用文件',
	integratedSearch_tecSupport_introductionDoc : '產品介紹文件',
	integratedSearch_tecSupport_TQDoc : '技術/質量文件',
	integratedSearch_tecSupport_crDoc : '證書/報告',
	integratedSearch_tecSupport_ptDoc : '產品培訓文件',

	integratedSearch_tecSupport_fileName : '文件名',
	integratedSearch_tecSupport_fileType : '文件類型',
	integratedSearch_tecSupport_download : '下載',
	integratedSearch_tecSupport_share : '國有',

	//제품지원-제품 카탈로그
	productSupport_productCatalog_tit : '產品目錄',
	productSupport_productCatalog_resultTxtAll : '所有搜索結果',
	productSupport_productCatalog_resultTxt1 : '總共搜索了 ',
	productSupport_productCatalog_resultTxt2 : '條搜索結果。',
	productSupport_productCatalog_publishedDate : '出版日期',

	//confirmSwal
	user_common_confirmSwal_noSearchInput : '請輸入您的搜索詞',
	user_common_confirmSwal_noSearchInput_desc : '',
	user_common_placeHolder_fileName : '文件名搜索',
	user_common_placeHolder_catalogName : '按目錄名稱搜索',

	//contact
	user_contact_tit : '接觸',
	user_contact_tel : '電話',
	user_contact_addr : '地址',
	user_contact_email : '電子郵件',
	user_contact_businessOffice : '營業所',
	user_contact_manager : '經理',

	//share modal
	user_shareModal_tit: '共享技術支持文件',
	user_shareModal_inputLabel: 'E-mail',
	user_shareModal_placeHolder: '輸入你的電子郵箱',
	user_shareModal_btnConfirm: '確認',
	user_shareModal_btnCancel: '取消',
	user_shareModal_confirmSwal_content1: '請輸入您的電子郵件地址',
	user_shareModal_confirmSwal_content2: '電子郵件格式不正確',

	//문서 다운
	user_docDownload_tit: '下載文件',

	//글로벌 네트워크 주소==============

	user_globalNetwork_Headquarters_tit : '總部',
	user_globalNetwork_Headquarters_seoul : 'Seoul Headquarters',
	user_globalNetwork_Headquarters_address : '344 Sapyeong-daero (1301-4 Seocho-dong), Seocho-gu, Seoul, Korea 06608',
	user_globalNetwork_Headquarters_call : '(82)-2-3480-5000',

	user_globalNetwork_CentralResearch_tit : '中央研究',
	user_globalNetwork_CentralResearch_subtit : 'Central Research',
	user_globalNetwork_CentralResearch_address : '17-5, Mabungro240Beon-gil. Giheung-gu, Yongin-si, Gyeonggi-do, Korea',
	user_globalNetwork_CentralResearch_call : '(82)-31-288-3000',

	user_globalNetwork_Factory_tit : '工廠',

	user_globalNetwork_Factory_Gapyeong : 'Gapyeong Plant',
	user_globalNetwork_Factory_Gapyeong_production : 'Glass Silica',
	user_globalNetwork_Factory_Gapyeong_address : '2, Muransan-gil, Gapyeong-eup, Gapyeong-gun, Gyeonggi-do, Korea',
	user_globalNetwork_Factory_Gapyeong_call : '(82)-31-580-1500',

	user_globalNetwork_Factory_Gimcheon : 'Gimcheon Plant',
	user_globalNetwork_Factory_Gimcheon_production : 'Cerak Wool',
	user_globalNetwork_Factory_Gimcheon_address : '39, Saneopdanji-ro, Eomo-myeon, Gimcheon-si, Gyeongsangbuk-do, Korea',
	user_globalNetwork_Factory_Gimcheon_call : '(82)-54-420-1700',

	user_globalNetwork_Factory_DaejukGypsumBoard : 'Daejuk Gypsum Board Plant',
	user_globalNetwork_Factory_DaejukGypsumBoard_production : 'Gypsum Board',
	user_globalNetwork_Factory_DaejukGypsumBoard_address : '15, Deajuk 2(i)-ro, Daesan-eup, Seosan-si, Chungcheongnam-do, Korea',
	user_globalNetwork_Factory_DaejukGypsumBoard_call : '(82)-41-660-7000',

	user_globalNetwork_Factory_DaejukSilicone : 'Daejuk Silicone Plant',
	user_globalNetwork_Factory_DaejukSilicone_production : 'Silicone',
	user_globalNetwork_Factory_DaejukSilicone_address : '35, Deajuk 2(i)-ro, Daesan-eup, Seosan-si, Chungcheongnam-do, Korea',
	user_globalNetwork_Factory_DaejukSilicone_call : '(82)-41-660-8700',

	user_globalNetwork_Factory_Munmak : 'Munmak Plant',
	user_globalNetwork_Factory_Munmak_production : 'Glass Wool',
	user_globalNetwork_Factory_Munmak_address : '106, Munmakgongdan-gil, Munmak-eup, Wonju-si, Gangwon-do, Korea',
	user_globalNetwork_Factory_Munmak_call : '(82)-33-749-4500',

	user_globalNetwork_Factory_Sejong : 'Sejong Plant',
	user_globalNetwork_Factory_Sejong_production : 'Fiberglass Continuous Filament',
	user_globalNetwork_Factory_Sejong_address : '40, Sojeonggu-gil, Jeonui-myeon, Sejong Special Self-Governing City, Korea',
	user_globalNetwork_Factory_Sejong_call : '(82)-44-550-5600',

	user_globalNetwork_Factory_Anseong : 'Anseong Plant',
	user_globalNetwork_Factory_Anseong_production : 'Building Coatings / Auto Refinish / Industrial Coatings / Plant Coatings',
	user_globalNetwork_Factory_Anseong_address : '100, Je4sandan-ro, Seoun-myeon, Anseong-si, Gyeonggi-do, Korea',
	user_globalNetwork_Factory_Anseong_call : '(82)-31-670-7777',

	user_globalNetwork_Factory_Asan : 'Asan Plant',
	user_globalNetwork_Factory_Asan_production : 'Flooring / Lami-Film',
	user_globalNetwork_Factory_Asan_address : '658-33, Asan-ro, Yeomchi-eup, Asan-si, Chungcheongnam-do, Korea',
	user_globalNetwork_Factory_Asan_call : '(82)-41-539-9000',

	user_globalNetwork_Factory_Yeocheon : 'Yeocheon Plant',
	user_globalNetwork_Factory_Yeocheon_production : 'Gypsum Board',
	user_globalNetwork_Factory_Yeocheon_address : '830-7 Sangam-ro, Yeosu-si, Jeollanam-do, Korea',
	user_globalNetwork_Factory_Yeocheon_call : '(82)-61-680-7800',

	user_globalNetwork_Factory_Yeoju : 'Yeoju Plant',
	user_globalNetwork_Factory_Yeoju_production : 'Glass',
	user_globalNetwork_Factory_Yeoju_address : '541, Yeojunamro, Ganam-eup, Yeoju-si, Gyeonggi-do, Korea',
	user_globalNetwork_Factory_Yeoju_call : '(82)-31-880-3000',

	user_globalNetwork_Factory_Yeongwol : 'Yeongwol Plant',
	user_globalNetwork_Factory_Yeongwol_production : 'Dolomite / Casmite',
	user_globalNetwork_Factory_Yeongwol_address : 'Wondongjae-ro, Buk-myeon, Yeongwol-gun, Gangwon-do, Korea',
	user_globalNetwork_Factory_Yeongwol_call : '(82)-33-370-1500',

	user_globalNetwork_Factory_Ulsan : 'Ulsan Plant',
	user_globalNetwork_Factory_Ulsan_production : 'Marine Coatings / Plant Coatings / Auto Coatings / Industrial Coatings',
	user_globalNetwork_Factory_Ulsan_address : '30, Bangeojinsunhwan-doro, Dong-gu, Ulsan, Korea',
	user_globalNetwork_Factory_Ulsan_call : '(82)-52-280-1717',

	user_globalNetwork_Factory_JeonjuBuilding : 'Jeonju Building Materials Plant',
	user_globalNetwork_Factory_JeonjuBuilding_production : 'Window Profiles / Metallic Bonding Ceramic',
	user_globalNetwork_Factory_JeonjuBuilding_address : '19, Wanjusandan 4(sa)-ro, Bongdong-eup, Wanju-gun, Jeollabuk-do, Korea',
	user_globalNetwork_Factory_JeonjuBuilding_call : '(82)-63-260-8800',

	user_globalNetwork_Factory_JeonjuPainting : 'Jeonju Painting Plant',
	user_globalNetwork_Factory_JeonjuPainting_production : 'Coatings / Resin / EMC / Powder Coatings',
	user_globalNetwork_Factory_JeonjuPainting_address : '764, Gwahak-ro, Bongdong-eup, Wanju-gun, Jeollabuk-do, Korea',
	user_globalNetwork_Factory_JeonjuPainting_call : '(82)-63-260-7000',

	user_globalNetwork_Factory_JeonjuSilicone : 'Jeonju Silicone Plant',
	user_globalNetwork_Factory_JeonjuSilicone_production : 'Silicone',
	user_globalNetwork_Factory_JeonjuSilicone_address : '801, Gwahak-ro, Bongdong-eup, Wanju-gun, Jeollabuk-do, Korea',
	user_globalNetwork_Factory_JeonjuSilicone_call : '(82)-63-260-1700',

	//영업소
	user_globalNetwork_businessOffice_tit : '商務辦公',

	user_globalNetwork_businessOffice_Seongnam : 'Seongnam Business office',
	user_globalNetwork_businessOffice_Seongnam_address : '210, Daewangpangyo-ro, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Seongnam_call : '(82)-31-728-6800',

	user_globalNetwork_businessOffice_GyeonggiNorth : 'Northern Gyeonggi Business office',
	user_globalNetwork_businessOffice_GyeonggiNorth_address : '2014, Goyang-daero, Deogyang-gu, Goyang-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_GyeonggiNorth_call : '(82)-31-841-0208',

	user_globalNetwork_businessOffice_Namyangju : 'Namyangju Branch office',
	user_globalNetwork_businessOffice_Namyangju_address : '44, Dasanjungang-ro 172beon-gil, Namyangju-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Namyangju_call : '(82)-31-554-4326',

	user_globalNetwork_businessOffice_Suwon : 'Suwon Business office',
	user_globalNetwork_businessOffice_Suwon_address : '472, Gyeongsu-daero, Paldal-gu, Suwon-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Suwon_call : '(82)-31-235-5001',

	user_globalNetwork_businessOffice_Ansan : 'Ansan Branch office',
	user_globalNetwork_businessOffice_Ansan_address : '92, Seonbugwangjang 1-ro, Danwon-gu, Ansan-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Ansan_subAddress : '(Sunbu-dong 1076-21)',
	user_globalNetwork_businessOffice_Ansan_call : '(82)-31-487-7534',

	user_globalNetwork_businessOffice_Hwaseong : 'Hwaseong Branch office',
	user_globalNetwork_businessOffice_Hwaseong_address : '14, Baranmanse-gil, Hyangnam-eup, Hwaseong-si, Gyeonggi-do, Republic of Korea',
	user_globalNetwork_businessOffice_Hwaseong_call : '(82)-31-487-7534',

	user_globalNetwork_businessOffice_Wonju : 'Wonju Business office',
	user_globalNetwork_businessOffice_Wonju_address : '2461, Bugwon-ro, Wonju-si, Gangwon-do, Republic of Korea',
	user_globalNetwork_businessOffice_Wonju_call : '(82)-33-744-6821',

	user_globalNetwork_businessOffice_Gangneung : 'Gangneung Branch office',
	user_globalNetwork_businessOffice_Gangneung_address : '135, Yeonju-ro, Yeongok-myeon, Gangneung-si, Gangwon-do, Republic of Korea',
	user_globalNetwork_businessOffice_Gangneung_call : '(82)-33-662-1705',

	user_globalNetwork_businessOffice_Daejeon : 'Daejeon Business office',
	user_globalNetwork_businessOffice_Daejeon_address : '150, Sintanjin-ro, Daedeok-gu, Daejeon, Republic of Korea',
	user_globalNetwork_businessOffice_Daejeon_call : '(82)-42-635-4323',

	user_globalNetwork_businessOffice_Cheongju : 'Cheongju Business office',
	user_globalNetwork_businessOffice_Cheongju_address : '1130, 2sunhwan-ro, Heungdeok-gu, Cheongju-si, Chungcheongbuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Cheongju_call : '(82)-43-262-4200',

	user_globalNetwork_businessOffice_Cheonan : 'Cheonan Business office',
	user_globalNetwork_businessOffice_Cheonan_address : '40, Sojeonggu-gil, Jeonui-myeon, Sejong-si, Republic of Korea',
	user_globalNetwork_businessOffice_Cheonan_call : '(82)-44-550-5601',

	user_globalNetwork_businessOffice_Dangjin : 'Dangjin Business office',
	user_globalNetwork_businessOffice_Dangjin_address : '6719, Seohae-ro, Sinpyeong-myeon, Dangjin-si, Chungcheongnam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Dangjin_call : '(82)-41-363-4266',

	user_globalNetwork_businessOffice_Jeonju : 'Jeonju Business office',
	user_globalNetwork_businessOffice_Jeonju_address : '84, Donggok-ro, Deokjin-gu, Jeonju-si, Jeollabuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Jeonju_call : '(82)-63-211-5300',

	user_globalNetwork_businessOffice_Gwangju : 'Gwangju Business office',
	user_globalNetwork_businessOffice_Gwangju_address : '270, Mujin-daero, Gwangsan-gu, Gwangju, Republic of Korea',
	user_globalNetwork_businessOffice_Gwangju_call : '(82)-62-943-8211',

	user_globalNetwork_businessOffice_Mokpo : 'Mokpo Branch office',
	user_globalNetwork_businessOffice_Mokpo_address : '274, Hugwang-daero, Samhyang-eup, Muan-gun, Jeollanam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Mokpo_subAddress : '(2112 Namak-ri)',
	user_globalNetwork_businessOffice_Mokpo_call : '(82)-61-280-5935',

	user_globalNetwork_businessOffice_Suncheon : 'Suncheon Business office',
	user_globalNetwork_businessOffice_Suncheon_address : '3, Jangseonbaegi-gil, Suncheon-si, Jeollanam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Suncheon_call : '(82)-61-722-7722',

	user_globalNetwork_businessOffice_Daegu : 'Daegu Business office',
	user_globalNetwork_businessOffice_Daegu_address : '111, Taepyeong-ro, Jung-gu, Daegu, Republic of Korea',
	user_globalNetwork_businessOffice_Daegu_call : '(82)-53-252-0227',

	user_globalNetwork_businessOffice_Gumi : 'Gumi Branch office',
	user_globalNetwork_businessOffice_Gumi_address : '103, Cheomdangieop 7-ro, Sandong-eup, Gumi-si, Gyeongsangbuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Gumi_call : '(82)-54-453-4530',

	user_globalNetwork_businessOffice_Pohang : 'Pohang Business office',
	user_globalNetwork_businessOffice_Pohang_address : '695, Huimang-daero, Nam-gu, Pohang-si, Gyeongsangbuk-do, Republic of Korea',
	user_globalNetwork_businessOffice_Pohang_call : '(82)-54-275-7601',

	user_globalNetwork_businessOffice_Ulsan : 'Ulsan Business office',
	user_globalNetwork_businessOffice_Ulsan_address : '28-17, Jinjangyutong-ro, Buk-gu, Ulsan, Republic of Korea',
	user_globalNetwork_businessOffice_Ulsan_call : '(82)-52-287-0811',

	user_globalNetwork_businessOffice_Busan : 'Busan Business office',
	user_globalNetwork_businessOffice_Busan_address : '1628, Jungang-daero, Geumjeong-gu, Busan, Republic of Korea',
	user_globalNetwork_businessOffice_Busan_call : '(82)-51-580-5200',

	user_globalNetwork_businessOffice_Changwon : 'Changwon Business office',
	user_globalNetwork_businessOffice_Changwon_address : '563, Muyeok-ro, Uichang-gu, Changwon-si, Gyeongsangnam-do, Republic of Korea',
	user_globalNetwork_businessOffice_Changwon_call : '(82)-55-265-3211',

	user_globalNetwork_businessOffice_Jeju : 'Jeju Business office',
	user_globalNetwork_businessOffice_Jeju_address : '340, Yeonsam-ro, Jeju-si, Jeju-do, Republic of Korea',
	user_globalNetwork_businessOffice_Jeju_call : '(82)-64-726-8870',

	//user_main 비주얼 스와이퍼
	user_main_visual01_tit : 'KCC，您的解決方案合作夥伴',
	user_main_visual01_descr : '我們為未來提供尖端的解決方案。',
	user_main_visual02_tit : '用先進材料推動明天進步的技術',
	user_main_visual02_descr : '灌封膠、絕緣材料、半導體及電子電器產品的芯材',
	user_main_visual03_tit : '我們擁有塑造未來的技術。',
	user_main_visual03_descr : '工程塑料原料，玻璃纖維長絲',

	//product_main 비주얼 스와이퍼
	product_main_visual_EMC_tit : 'EMC',
	product_main_visual_EMC_descr : '可應用於各種半導體，具有優異的加工性、成型性和可靠性，半導體性能穩定。',
	product_main_visual_Adhesive_tit : 'Adhesive',
	product_main_visual_Adhesive_descr : '作為半導體用粘合材料，可應用於具有優異加工性和可靠性的高性能半導體。',
	product_main_visual_MetalizedCeramics_tit : 'Metalized Ceramic',
	product_main_visual_MetalizedCeramics_descr : '採用KCC陶瓷管的VI(V​​acuum Interrupter)用陶瓷具有優良的粘結性能、結構緊湊性和真空密封性</br>應用於輸配電用真空斷路器，被選為世界一流產品連續12年。</br> >此外，我們大量生產和供應各種功率管和金屬鍵合陶瓷產品。',
	product_main_visual_CeramicSubstrates_tit : 'Ceramic Substrate',
	product_main_visual_CeramicSubstrates_descr : '使用DCB和AMB方法將銅粘合到陶瓷基板上，用作功率模塊半導體的基板。</br>將銅粘合到各種陶瓷上，具有滿足客戶需求的強度和散熱性能</br>對於汽車。 、工業及家電功率模塊半導體基板',
	product_main_visual_GlassFiber_tit : 'Glass fiber',
	product_main_visual_GlassFiber_descr : '是一種用於增強工程塑料性能的玻璃纖維。</br>適用於電子電氣、家電、汽車、建築、船舶等各個行業。</br>重量輕，尺寸穩定，延展性低、耐冷化學性等。它提供了可以響應每個行業需求的物理性能。',

	//데이터 시트, 엑셀 다운로드
	datasheet_download : 'Excel 下載',
	datasheet_fullScreen : '全屏',
	datasheet_compareProducts : '比較產品',
	datasheet_fullList : '完整列表',

	// design rule 다운로드
	design_rule_download : 'Design Rule 下載',

	//중국 도시
	globalNetwork_china_Shanghai : '上海',
	globalNetwork_china_Beijing : '北京',
	globalNetwork_china_Guangzhou : '廣州',
	globalNetwork_china_Chongqing : '重慶',

	//외부파일
	filetype_externalFile : '外部文件',

	// 팝업
	hideToday: '今日不再显示',
	close: '关闭',

}
